<template>
	<div class="bj">
		<div>
			<div class="contents" style="margin-bottom: 6px;">
				<div class="tops">
					<div class="logo"><img src="../../assets/index/logo.png" /></div>
					<div class="lxwm"><img src="../../assets/lxwm.png" /></div>
				</div>
				<div class="nav">
					<div class="grid-content" @click="goTo('/login')">
						<div><img src="../../assets/left.svg" />返回登录</div>
					</div>
				</div>

			</div>
			<div class="routers" style="overflow-y: auto;height: calc(100vh - 216px);">
				<div class="kuan">
					<div class="froms">
						<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"
							class="demo-ruleForm">
							<div class="titles">
								基本信息
							</div>
							<div style="width:1096px ;margin: 0 auto;">
								<el-row>
									<el-col :span="12">
										<el-form-item label="姓名" prop="nickname">
											<el-input v-model="ruleForm.nickname" placeholder="请填写姓名"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="手机号" prop="mobile">
											<el-input v-model="ruleForm.mobile" placeholder="请填写手机号"></el-input>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="12">
										<el-form-item label="邮箱" prop="email">
											<el-input v-model="ruleForm.email" placeholder="请填写邮箱"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="身份证号" prop="card">
											<el-input v-model="ruleForm.card" placeholder="请填写身份证号">
											</el-input>
										</el-form-item>
									</el-col>
								</el-row>
								<el-form-item label="单位名称" prop="company">
									<el-input v-model="ruleForm.company" v-if="ruleForm.group_id=='2'"
										placeholder="请填写单位名称">
									</el-input>
									<el-select v-else v-model="ruleForm.company" placeholder="请选择单位名称"
										style="width: 100%;">
										<el-option v-for="item in Companydata" :key="item.value" :label="item.label"
											:value="item.label">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="个人证件照">
									<el-upload class="avatar-uploader" :action="fileimg.uploadUrl"
										:show-file-list="false" :on-success="handleAvatarSuccess"
										:before-upload="beforeAvatarUpload">
										<img v-if="imageUrl" :src="imageUrl" class="avatar" />
										<i v-else class="el-icon-plus avatar-uploader-icon"></i>
									</el-upload>
									<div class="upload-but">
										<div>
											<p style="color: #FF0000;">照片上传注意事项</p></br>
											<p>上传电子版照片为近期免冠正面证件照，格式为jpg，大小为50K～100k，2寸照片。</p></br>
											<p>照片必须清晰反映本人特征，
												<span style="color: #FF0000;">如生活照、照片模糊或虚、红‘X’等情况，</span>
												均不能通过照片审核
											</p></br>
										</div>
									</div>
								</el-form-item>
							</div>
							<div class="titles">
								账号设置
							</div>
							<div style="width:1096px ;margin: 0 auto;margin-bottom: 59px;">
								<el-form-item label="账号">
									<el-input v-model="ruleForm.card" placeholder="请填写身份证号" :readonly='true'></el-input>
								</el-form-item>
								<el-row>
									<el-col :span="12">
										<el-form-item label="密码" prop="password">
											<el-input v-model="ruleForm.password" show-password
												placeholder="请填写密码(6-30个字符)">
											</el-input>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="确认密码" prop="password_confirm">
											<el-input v-model="ruleForm.password_confirm" show-password
												placeholder="请填写确认密码">
											</el-input>
										</el-form-item>
									</el-col>
								</el-row>
							</div>
							<el-form-item>
								<el-button type="primary" size="medium" @click="submitForm('ruleForm')">注册
								</el-button>
								<el-button @click="resetForm('ruleForm')">重置</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
				<Foot></Foot>
			</div>
		</div>

	</div>
	<!-- <div>
		<Menu></Menu>
		<div
			style="background-image:url(https://files.gsjtpxzx.com/public/assets/front/image/12.png);background-size: 100% 807px;height: 850px;">
			<div class="bjs"></div>
			<div class="kuan">
				<div class="froms">
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
						<div class="titles">
							基本信息
						</div>
						<div style="width:1096px ;margin: 0 auto;">
							<el-row>
								<el-col :span="12">
									<el-form-item label="姓名" prop="nickname">
										<el-input v-model="ruleForm.nickname" placeholder="请填写姓名"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="手机号" prop="mobile">
										<el-input v-model="ruleForm.mobile" placeholder="请填写手机号"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="12">
									<el-form-item label="邮箱" prop="email">
										<el-input v-model="ruleForm.email" placeholder="请填写邮箱"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="身份证号" prop="card">
										<el-input v-model="ruleForm.card" placeholder="请填写身份证号">
										</el-input>
									</el-form-item>
								</el-col>
							</el-row>
							<el-form-item label="单位名称" prop="company">
								<el-input v-model="ruleForm.company" v-if="ruleForm.group_id=='2'"
									placeholder="请填写单位名称">
								</el-input>
								<el-select v-else v-model="ruleForm.company" placeholder="请选择单位名称" style="width: 100%;">
									<el-option v-for="item in Companydata" :key="item.value" :label="item.label"
										:value="item.label">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="个人证件照">
								<el-upload class="avatar-uploader" :action="fileimg.uploadUrl" :show-file-list="false"
									:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
									<img v-if="imageUrl" :src="imageUrl" class="avatar" />
									<i v-else class="el-icon-plus avatar-uploader-icon"></i>
								</el-upload>
								<div class="upload-but">
									<div>
										<p style="color: #FF0000;">照片上传注意事项</p></br>
										<p>上传电子版照片为近期免冠正面证件照，格式为jpg，大小为50K～100k，2寸照片。</p></br>
										<p>照片必须反清晰反映本人特征，
											<span style="color: #FF0000;">如生活照、照片模糊或虚、红‘X’等情况，</span>
											均不能通过照片审核
										</p></br>
									</div>
								</div>
							</el-form-item>
						</div>
						<div class="titles">
							账号设置
						</div>
						<div style="width:1096px ;margin: 0 auto;margin-bottom: 59px;">
							<el-form-item label="账号">
								<el-input v-model="ruleForm.card" placeholder="请填写身份证号" :readonly='true'></el-input>
							</el-form-item>
							<el-row>
								<el-col :span="12">
									<el-form-item label="密码" prop="password">
										<el-input v-model="ruleForm.password" show-password
											placeholder="请填写密码(6-30个字符)">
										</el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="确认密码" prop="password_confirm">
										<el-input v-model="ruleForm.password_confirm" show-password
											placeholder="请填写确认密码">
										</el-input>
									</el-form-item>
								</el-col>
							</el-row>
						</div>
						<el-form-item>
							<el-button type="primary" size="medium" @click="submitForm('ruleForm')">注册
							</el-button>
							<el-button @click="resetForm('ruleForm')">重置</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>

		</div> -->
	<!-- <Foot></Foot>
	</div> -->
</template>

<script>
	import Menu from '../../components/menu.vue'
	import Foot from '@/components/foot.vue'
	export default {
		components: {
			Menu,
			Foot
		},
		data() {
			return {
				shows: {},
				ruleForm: {
					username: '',
					password: '',
					password_confirm: '',
					nickname: '',
					mobile: '',
					email: '',
					card: '',
					company: '',
					learning_type: 0,
					picture: '',
					group_id: ''
				},
				rules: {
					password: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '支持字母、数字、下划线组合，长度6-20位字符',
							trigger: 'blur'
						}
					],
					password_confirm: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '支持字母、数字、下划线组合，长度6-20位字符',
							trigger: 'blur'
						}
					],
					company: [{
						required: true,
						message: '请输入单位名称',
						trigger: 'blur'
					}],
					nickname: [{
						required: true,
						message: '请输入真实姓名',
						trigger: 'blur'
					}],
					mobile: [{
						required: true,
						pattern: /^1\d{10}$/,
						message: '请输入正确的手机号',
						trigger: 'blur'
					}],
					email: [{
						required: true,
						pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/,
						message: '请输入正确的邮箱',
						trigger: 'blur'
					}],
					card: [{
						required: true,
						pattern: /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
						message: '请输入正确的身份证号码',
						trigger: 'blur'
					}]
				},
				reveal: true,
				fileimg: {
					uploadUrl: this.$uploadApi,
				},
				imageUrl: '',
				//教育类别
				Learningdata: [],
				//单位名称
				Companydata: []
			};
		},
		created() {
			this.ruleForm.group_id = this.$route.query.group_id
			this.getCompany()
			//this.getLearningType()
			// if (this.ruleForm.group_id == '1') {
			// 	this.rules.learning_type = [{
			// 		required: true,
			// 		message: '请选择教育类别',
			// 		trigger: 'blur'
			// 	}]
			// }
		},
		methods: {
			goTo(path) {
				this.defaultStay = path
				window.sessionStorage.setItem('leftMenuDefaultKey', path)
				this.$router.replace(path);
			},
			//获取单位名称
			getCompany() {
				this.$http({
						method: 'POST',
						url: '/index/getCompany',
						headers: {
							requireAuth: false // 这里通过设置requireAuth为true来启用token检查
						},
					})
					.then(response => {
						if (response.code == 1) {
							this.Companydata = response.data
						} else {
							this.$message(response.msg);
						}

					})
					.catch(error => {
						console.log(error)
					})
			},
			//获取教育类别
			getLearningType() {
				this.$http({
						method: 'POST',
						url: '/index/getLearningType',
						headers: {
							requireAuth: false // 这里通过设置requireAuth为true来启用token检查
						},
					})
					.then(response => {
						if (response.code == 1) {
							this.Learningdata = response.data
						} else {
							this.$message(response.msg);
						}

					})
					.catch(error => {
						console.log(error)
					})
			},
			//上传证件照
			handleAvatarSuccess(res, file) {
				this.imageUrl = URL.createObjectURL(file.raw);
				this.ruleForm.picture = file.response.data.url
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 124 < 1;
				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 格式!');
					return isJPG && isLt2M;
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 100KB!');
					return isJPG && isLt2M;
				}
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.ruleForm.username = this.ruleForm.card
						if (this.ruleForm.password == this.ruleForm.password_confirm) {
							this.$http({
									method: 'POST',
									url: '/user/register',
									headers: {
										requireAuth: false // 这里通过设置requireAuth为true来启用token检查
									},
									data: this.ruleForm
								})
								.then(response => {
									if (response.code == 1) {
										this.$message({
											message: response.msg,
											type: 'success'
										});
										this.$router.push({
											path: "/index",
										})
									} else {
										this.$message(response.msg);
									}

								})
								.catch(error => {
									console.log(error)
								})
						} else {
							this.$message.error('两次密码输入不一致');
						}
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
		},
	}
</script>

<style lang="scss" scoped>
	.bj {
		background-image: url(../../assets/bj.jpg);
		background-repeat: no-repeat;
		background-size: 100% auto;

	}

	.contents {
		width: 1400px;
		margin: 0 auto;
	}

	.tops {
		overflow: hidden;
		height: 140px;
	}

	.logo {
		width: 805px;
		height: 73px;
		padding-top: 43px;
		float: left;
	}

	.logo img {
		width: 805px;
		height: auto;
	}

	.lxwm {
		float: right;
		width: 330px;
		height: 68px;
		padding-top: 43px;
	}

	.lxwm img {
		width: 330px;
		height: 68px;
	}

	.nav {
		width: 100%;
		height: 50px;
		background: #FFFFFF;
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
		border-radius: 5px;
		margin-top: 31px;
	}

	.grid-content {
		width: 168px;
		height: 46px;
		float: left;
		line-height: 50px;
		font-size: 18px;
		font-weight: bold;
		color: #1072DA;
		cursor: pointer;
	}

	.grid-content div {
		width: 114px;
		height: 45px;
		margin-left: 10px;

		img {
			width: 20px;
			height: 20px;
			padding-top: 14px;
			float: left;
		}
	}

	.back {
		background: #2891fd !important;
		color: #ffffff !important;
	}

	.bjs {
		width: 100%;
		height: 400px;
		padding-top: 5px;
		background: linear-gradient(180deg, rgba(14, 155, 218, 0.5), rgba(0, 136, 255, 0) 100%);
	}

	/deep/ .el-form-item {
		margin-bottom: 18px !important;
	}

	/deep/ .el-form-item__content {
		text-align: center;


		.el-button--primary {
			margin-right: 59px;
			width: 202px;
			height: 43px;
			background: #0662B3;
			border-radius: 22px;

		}

		.el-button--default {
			width: 202px;
			height: 43px;
			border-radius: 22px;
			border: 1px solid #0662B3;
		}
	}

	/* 滚动条整体 */
	.routers::-webkit-scrollbar {
		height: 20px;
		width: 2px;
	}

	/* 两个滚动条交接处 -- x轴和y轴 */
	.routers::-webkit-scrollbar-corner {
		background-color: transparent;
	}

	/* 滚动条滑块 */
	.routers::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #535353;
	}

	/* 滚动条轨道 */
	.routers::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 10px;
		background: #ededed;
	}

	/* 我的*/
	.upload-but {
		line-height: 6px;
		float: left;
		text-align: left;
		margin-left: 15px;
		margin-top: 20px;
	}

	.upload-but p {

		height: 30px;
	}

	.upload-img {
		width: 120px;
		height: 158px;
		float: left;
		border: 1px solid #eee;
	}

	.upload-img img {
		width: 120px;
		height: 158px;

	}

	.avatar-uploader {
		width: 124px;
		float: left;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		border: 1px solid #d9d9d9;
		color: #8c939d;
		width: 125px;
		height: 165px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 125px;
		height: 165px;
		display: block;
	}

	/deep/.el-tabs__item {
		font-size: 16px !important;
	}

	.kuan {
		width: 1400px;
		height: 778px;
		margin: 10px auto;
		background: #FFFFFF;
		box-shadow: 0px 2px 7px 0px rgba(6, 98, 179, 0.25);
		border-radius: 6px;
		border: 1px solid rgba(0, 0, 0, 0.07);

		.froms {
			width: 1180px;
			margin: 0 auto;

			.titles {
				width: 1166px;
				height: 59px;
				line-height: 59px;
				border-bottom: 1px dashed rgba(6, 98, 179, 0.53);
				font-size: 18px;
				font-weight: 500;
				color: #0162B3;
				padding-left: 14px;
				margin-bottom: 27px;
			}
		}
	}

	.registerHeader___1FDoe {
		line-height: 80px;
		// display: flex;
		align-items: center;
		margin: 20px 0 0 0px;
		text-align: center;

		h1 {
			margin: 0 0 0 42px;
		}


	}

	.step___Nn6Td {
		width: 98%;
		margin: 10px auto 26px auto;
		height: 39px;
		background-color: #E5E5E5;
		display: flex;

		.stepItemIndex___7bLRQ {
			background: #2891fd;
			color: #ffffff;
			width: 152px;
			height: 100%;
			position: relative;
			background: #e5e5e5;
			line-height: 39px;
			text-align: center;
			font-size: 16px;
			color: rgba(0, 0, 0, 0.5);
			font-weight: 400;

			img {
				width: 18px;
				height: 20px;
				margin: -3px 9px 0 15px;
				vertical-align: middle;
			}
		}

		.stepItem___3kij8 {
			width: 152px;
			height: 100%;
			position: relative;
			background: #e5e5e5;
			line-height: 39px;
			text-align: center;
			font-size: 16px;
			color: rgba(0, 0, 0, 0.5);
			font-weight: 400;



			img {
				width: 18px;
				height: 20px;
				margin: -3px 9px 0 15px;
				vertical-align: middle;
			}
		}

		.stepItem___3kij8::before {
			left: 102%;
			border-left: 24px solid #ffffff;
			z-index: 8;
			position: absolute;
			top: 0;
			content: '';
			width: 0;
			height: 0;
			border-top: 21px solid transparent;
			border-bottom: 18px solid transparent;
		}

		.stepItem___3kij8::after {
			left: 100%;
			border-left: 24px solid #E5E5E5;
			z-index: 9;
			position: absolute;
			top: 0;
			content: '';
			width: 0;
			height: 0;
			border-top: 21px solid transparent;
			border-bottom: 18px solid transparent;
		}

		.stepItemIndex___7bLRQ::before {
			left: 102%;
			border-left: 24px solid #ffffff;
			z-index: 8;
			position: absolute;
			top: 0;
			content: '';
			width: 0;
			height: 0;
			border-top: 21px solid transparent;
			border-bottom: 18px solid transparent;
		}

		.stepItemIndex___7bLRQ::after {
			left: 100%;
			border-left: 24px solid #E5E5E5;
			z-index: 9;
			position: absolute;
			top: 0;
			content: '';
			width: 0;
			height: 0;
			border-top: 21px solid transparent;
			border-bottom: 18px solid transparent;
		}
	}
</style>
